import { init as initApm } from "@elastic/apm-rum";
var apm = initApm({
  // Set required service name (allowed characters: a-z, A-Z, 0-9, -, _, and space)
  serviceName: "arist-dashboard",

  // Set custom APM Server URL (default: http://localhost:8200)
  serverUrl:
    "https://779c536ab89047abbf1c1c8bbea11f78.apm.us-east-2.aws.elastic-cloud.com:443",

  // Set service version (required for source map feature)
  serviceVersion: `${process.env.VUE_APP_VERSION}`,
  environment: `${process.env.VUE_APP_ENVIRONMENT}`,
  distributedTracingOrigins: [
    "https://api.arist.co",
    "http://localhost:8080",
    "http://aristapi-dev.us-east-2.elasticbeanstalk.com/"
  ]
});
export default apm;
